import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 100%;
`;
